import { useMemo, useState } from "react";
import { parseCategories, parseTags, slugifyCategory } from "./browseUtils";
import "./TermCard.css";

const BG_MAP = {
    "bug-catching": "bugs.webp",
    bugs: "bugs.webp",
    cooking: "cooking.webp",
    crafting: "crafting.webp",
    fishing: "fishing.webp",
    foraging: "foraging.webp",
    gardening: "gardening.webp",
    hunting: "hunting.webp",
    mining: "mining.webp",
    ranching: "ranching.webp",
    uncategorized: "uncategorized.webp",
};

function pickBgFile(categories) {
    for (const c of categories) {
        const slug = slugifyCategory(c);
        if (BG_MAP[slug]) return BG_MAP[slug];
    }
    return BG_MAP.uncategorized;
}

export default function TermCard({ item, onOpen }) {
    const [expanded, setExpanded] = useState(false);

    const categories = useMemo(
        () => parseCategories(item?.category, 2),
        [item?.category],
    );

    const tags = useMemo(() => parseTags(item?.tags), [item?.tags]);

    const bgUrl = useMemo(() => {
        const file = pickBgFile(categories);
        return `${process.env.PUBLIC_URL}/bg/${file}`;
    }, [categories]);

    return (
        <div
            className={`term-card term-card-bg ${expanded ? "term-card-expanded" : ""}`}
        >
            <div
                className="term-card-bgLayer"
                style={{ backgroundImage: `url(${bgUrl})` }}
                aria-hidden="true"
            />

            <div className="term-top">
                <div className="term-title">{item?.term}</div>

                <div className="term-meta">
                    <div className="term-category-pills">
                        {categories.slice(0, 1).map((c) => (
                            <span key={c} className="pill">
                                {c}
                            </span>
                        ))}

                        {categories.length > 1 && (
                            <span
                                className="pill pill-muted"
                                title={categories.slice(1).join(", ")}
                            >
                                +{categories.length - 1} more
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div
                className={`term-definition ${expanded ? "expanded" : "collapsed"}`}
            >
                {item?.definition}
            </div>

            <button
                className="term-expand-inline"
                onClick={() => setExpanded((v) => !v)}
                type="button"
                aria-expanded={expanded}
            >
                {expanded ? "Collapse ▲" : "Expand ▼"}
            </button>

            {tags.length > 0 && (
                <div className="term-tags">
                    {tags.slice(0, 2).map((t) => (
                        <span key={t} className="pill pill-muted">
                            {t}
                        </span>
                    ))}

                    {tags.length > 2 && (
                        <span
                            className="pill pill-muted"
                            title={tags.slice(2).join(", ")}
                        >
                            +{tags.length - 2} more
                        </span>
                    )}
                </div>
            )}

            <div className="term-actions">
                <button
                    className="term-action-btn primary"
                    onClick={() => onOpen(item.id)}
                    type="button"
                >
                    Open
                </button>
            </div>
        </div>
    );
}
